// Added by Sejune Oh on 2020-04-06
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    Table as MaterialUITable,
    TableProps as MaterialUITableProps
} from '@material-ui/core'

interface TableBaseProps { }
export type TableProps = Partial<MaterialUITableProps> & TableBaseProps

export const Table: FC<TableProps> = ({ ...props }) => {
    return <MaterialUITable {...props}></MaterialUITable>
}
